"use client";

import { useScrollSpy } from "@/hooks/useScrollSpy";
import { Container } from "@repo/ui";
import clsx from "clsx";

type CourseNavigationProps = {
  data: {
    courseNavigation: {
      id: string;
      title: string;
    }[];
  };
};

const CourseNavigation = ({ data }: CourseNavigationProps) => {
  const activeId = useScrollSpy(124);
  return (
    <section className="shadow-md bg-common-white sticky top-[64px] left-0 right-0 z-10">
      <Container>
        <ul className="sm:grid grid-flow-row sm:grid-flow-col gap-2 justify-items-center hidden">
          {data.courseNavigation.map((section) => (
            <li key={section.id}>
              <a
                href={`#${section.id}`}
                className={clsx("block py-4 transition-all", {
                  "border-b-2 border-primary-main text-primary-main":
                    activeId === section.id,
                })}
              >
                {section.title}
              </a>
            </li>
          ))}
        </ul>
      </Container>
    </section>
  );
};

export default CourseNavigation;
